import ElectionCard from './ElectionCard';

export default ElectionCard;
